import React from 'react';
import { ShieldCheck, ExternalLink, Heart, Globe, Lock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="w-full bg-white dark:bg-[#070a12] border-t border-slate-200 dark:border-slate-800/80 pt-12 pb-8 transition-colors duration-300 text-slate-600 dark:text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          
          {/* Brand Info */}
          <div className="space-y-4 md:col-span-1">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-cyan-500 via-indigo-500 to-purple-600 p-[2px] flex items-center justify-center shadow-md">
                <div className="w-full h-full bg-white dark:bg-[#0b0f19] rounded-[6px] flex items-center justify-center">
                  <ShieldCheck className="w-4 h-4 text-cyan-500 dark:text-cyan-400" />
                </div>
              </div>
              <span className="font-bold text-base bg-gradient-to-r from-cyan-600 via-indigo-600 to-purple-600 dark:from-cyan-400 dark:via-indigo-300 dark:to-purple-400 bg-clip-text text-transparent">
                SyncProtocol
              </span>
            </div>
            <p className="text-xs leading-relaxed text-slate-500 dark:text-slate-400">
              Decentralized cross-chain resolution protocol establishing secure remote handshakes between non-custodial wallets and node endpoints.
            </p>
            <div className="text-xs font-medium text-slate-600 dark:text-slate-300">
              Powered by <a href="https://tickethelps.com" target="_blank" rel="noreferrer" className="text-cyan-600 dark:text-cyan-400 hover:underline font-semibold">Tickethelps.com</a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-slate-200 mb-3 font-mono">
              Protocol
            </h4>
            <ul className="space-y-2 text-xs">
              <li><a href="#sync-categories" className="hover:text-cyan-500 transition-colors">Resolution Categories</a></li>
              <li><a href="#sync-categories" className="hover:text-cyan-500 transition-colors">Cross-Chain Bridge</a></li>
              <li><a href="#sync-categories" className="hover:text-cyan-500 transition-colors">Assets Recovery</a></li>
              <li><a href="#sync-categories" className="hover:text-cyan-500 transition-colors">Smart Contract Audit</a></li>
            </ul>
          </div>

          {/* Security & Network */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-slate-200 mb-3 font-mono">
              Infrastructure
            </h4>
            <ul className="space-y-2 text-xs">
              <li className="flex items-center gap-1.5"><Globe className="w-3.5 h-3.5 text-cyan-500" /> Node Endpoints (18 Active)</li>
              <li className="flex items-center gap-1.5"><Lock className="w-3.5 h-3.5 text-emerald-500" /> 256-bit SSL Handshake</li>
              <li className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span> Mainnet Operational</li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-slate-200 mb-3 font-mono">
              Security Notice
            </h4>
            <p className="text-[11px] leading-relaxed text-slate-500 dark:text-slate-500">
              All protocol interactions are encrypted locally and executed securely through decentralized node relays.
            </p>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-200 dark:border-slate-800/80 flex flex-col sm:flex-row items-center justify-between text-xs gap-4">
          <div className="text-slate-500 dark:text-slate-500 font-mono">
            &copy; {new Date().getFullYear()} SyncProtocol. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-slate-500 dark:text-slate-400">
            <span className="hover:text-cyan-500 cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-cyan-500 cursor-pointer transition-colors">Terms of Service</span>
            <span className="hover:text-cyan-500 cursor-pointer transition-colors">Security Whitepaper</span>
          </div>
        </div>
      </div>
    </footer>
  );
}